import { render, staticRenderFns } from "./TicketAcaoRegraEdit.vue?vue&type=template&id=3c76c9ab&scoped=true"
import script from "./TicketAcaoRegraEdit.vue?vue&type=script&lang=js"
export * from "./TicketAcaoRegraEdit.vue?vue&type=script&lang=js"
import style0 from "./TicketAcaoRegraEdit.vue?vue&type=style&index=0&id=3c76c9ab&prod&scoped=true&lang=css"
import style1 from "./TicketAcaoRegraEdit.vue?vue&type=style&index=1&id=3c76c9ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76c9ab",
  null
  
)

export default component.exports